<div class="template-item-search-select">
  <div class="source-item-search">
    <i class="fas fa-search source-item-search-icon" aria-hidden="true"></i>
    <input
      type="text"
      class="source-item-search-input"
      [value]="searchQuery"
      (input)="onSearchInput($any($event.target).value)"
      (keydown)="onSearchKeydown($event)"
      [placeholder]="placeholder"
      aria-label="Search template items"
    />
  </div>
  <div class="source-item-list-wrapper">
    <ul class="source-item-list" *ngIf="filteredItems.length > 0">
      <li
        *ngFor="let option of filteredItems"
        class="source-item-row"
        [class.source-item-row--selected]="option.id === selectedItemId">
        <div class="source-item-label">
          <span
            class="source-item-left"
            tabindex="-1"
            (click)="onItemClick(option)"
            (keydown)="onOptionKeydown(option, $event)">
            <span class="source-item-text">{{ option.value }}</span>
            <i
              *ngIf="option.id === selectedItemId"
              class="fas fa-check source-item-selected-icon"
              aria-hidden="true"
            ></i>
          </span>
        </div>
      </li>
    </ul>
    <p *ngIf="filteredItems.length === 0" class="no-items-message">
      {{ debouncedSearchQuery ? 'No matching template items.' : 'No template items available.' }}
    </p>
  </div>
</div>
